/* @flow strict */

import _ from 'lodash';

const validateTicketMainInfo = (data: {}, scrollCb: (HTMLElement) => void): boolean => {
  let isValid = true;

  const defaultNodeEl = {
    style: {}
  };

  const nameEl = document.querySelector('#name');
  const nameVMsg = nameEl.nextSibling || defaultNodeEl;

  const urlEl = document.querySelector('#url_name');
  const urlVMsg = urlEl.nextSibling || defaultNodeEl;

  const descrEl = document.querySelector('.ReactSummernote .note-editable');
  const descrVMsg = descrEl.parentNode.parentNode.parentNode.parentNode.querySelector('.vMsg');

  const locEl = document.querySelector('.LocAutocomplete input');
  const locVMsg = locEl.nextSibling || defaultNodeEl;

  const tzEl = document.querySelector('.timezoneSelect select');
  const tzVMsg = tzEl.nextSibling || defaultNodeEl;

  let invalidEl = null;

  if (!_.size(_.trim(data.name))) {
    nameEl.classList.add('validationElement');
    nameVMsg.style.display = 'block';

    invalidEl = nameEl;

    isValid = false;
  }

  if (!_.size(_.trim(data.url_name))) {
    urlEl.classList.add('validationElement');
    urlVMsg.style.display = 'block';
    invalidEl = urlEl;

    isValid = false;
  }

  if (!_.size(_.trim(data.long_description.replace(/<[^>]*>/g, ' ')))) {
    descrEl.classList.add('validationElement');
    descrVMsg.style.display = 'block';
    invalidEl = descrEl;

    isValid = false;
  }

  if (!_.size(_.trim(data.autoCompleteValue.formatted_address))) {
    locEl.classList.add('validationElement');
    locVMsg.style.display = 'block';
    invalidEl = locEl;

    isValid = false;
  }

  if (!_.size(_.trim(data.time_zone_id))) {
    tzEl.classList.add('validationElement');
    tzVMsg.style.display = 'block';
    invalidEl = tzEl;

    isValid = false;
  }

  if (scrollCb) {
    scrollCb(invalidEl);
  }

  return isValid;
};

export default validateTicketMainInfo;
